import React, { useState } from 'react';
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram, Youtube } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const columns = [
  {
    title: 'Company',
    links: ['About Us', 'Founder', 'Careers', 'Blog', 'Contact'],
  },
  {
    title: 'Services',
    links: ['Company Registration', 'GST Registration', 'ITR Filing', 'Trademark', 'FDI Compliance', 'FSSAI'],
  },
  {
    title: 'Resources',
    links: ['Tax Updates', 'Compliance Calendar', 'Downloads', 'FAQs', 'Help Center'],
  },
];

export default function Footer() {
  const { toast } = useToast();
  const [email, setEmail] = useState('');

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast({ title: 'Subscribed!', description: `We'll keep ${email} in the loop.` });
    setEmail('');
  };

  return (
    <footer id="footer" className="bg-[#0b3d5b] text-white">
      {/* Call banner */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-8 flex flex-wrap items-center justify-between gap-4">

          <form onSubmit={subscribe} className="flex w-full md:w-auto max-w-md">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email for updates"
              className="flex-1 px-4 py-3 rounded-l-lg text-slate-800 text-sm outline-none border-2 border-transparent focus:border-orange-400"
            />
            <button type="submit" className="bg-orange-500 hover:bg-orange-600 px-5 py-3 rounded-r-lg font-semibold text-sm transition-colors">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Main */}
      <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-5 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center font-bold">RP</div>
            <div>
              <div className="font-extrabold text-lg">Register Point</div>
              <div className="text-[10px] uppercase tracking-wider text-white/70">Tax &middot; Compliance &middot; Consulting</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/80 leading-relaxed">
            India&apos;s trusted online marketplace connecting businesses with verified Chartered Accountants, Company Secretaries and tax experts across 500+ cities.
          </p>
          <div className="mt-5 space-y-2 text-sm text-white/80">
            <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-orange-300" /> info@registerpoint.com</div>
            <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-orange-300" /> Laxmi Nagar, Delhi &mdash; 110092</div>
          </div>
          <div className="mt-5 flex gap-3">
            {[Facebook, Twitter, Linkedin, Instagram, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        {columns.map((col) => (
          <div key={col.title}>
            <h4 className="font-bold mb-4 text-orange-300 text-sm uppercase tracking-wider">{col.title}</h4>
            <ul className="space-y-2">
              {col.links.map((l) => (
                <li key={l}><a href="#" className="text-sm text-white/80 hover:text-white transition-colors">{l}</a></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-2 text-xs text-white/70">
          <div>&copy; {new Date().getFullYear()} Register Point. All Rights Reserved.</div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
            <a href="#" className="hover:text-white">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
